module.exports = __webpack_public_path__ + "img/ic_cb_blanc.09fc00ab.svg";